import { HouseholdView } from '@/features/household/HouseholdView'

export function HouseholdPage() {
  return (
    <main className="min-h-screen bg-canvas">
      <div className="max-w-2xl mx-auto px-4 py-8">
        <HouseholdView />
      </div>
    </main>
  )
}
